import React from "react";
import { PulseLoader } from "react-spinners";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <PulseLoader color="#3D5EE1" size={20} />
    </div>
  );
};

export default Loader;
